(ns teamoesterreich.admin-mode.lebensretter.lr-user.toe-sort-table
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [goog.date.DateTime]
            [reagent-material-ui.components :as mui]
            [reagent-material-ui.icons.add :as ic-add]
            [reagent-material-ui.icons.edit :as ic-edit]
            [reagent-material-ui.icons.email :refer [email]]
            [reagent-material-ui.icons.label-important :refer [label-important]]
            [reagent-material-ui.icons.speaker-notes :refer [speaker-notes]]
            [reagent-material-ui.icons.warning :as ic-warning]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.lr-clearance :as d-lrClearance]
            [teamoesterreich.admin-mode.data.organisation :as d-organisation]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.clearance-modal :as clearance-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.correspondence-modal :as correspondence-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-assign-modal :as document-assign-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-extend-modal :as document-extend-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-identity-modal :as document-identity-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-selfExplain-modal :as document-selfExplain-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.document-training-modal :as document-training-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.qualification-modal :as qualification-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.extend-modal :as extend-modal]
            [teamoesterreich.admin-mode.lebensretter.lr-user.modal.marker-modal :as marker-modal]
            [teamoesterreich.admin-mode.ui-helper.preview-modal :as preview-modal]
            [teamoesterreich.element.backend-file :as backend-file]
            [teamoesterreich.util.log :as log]
            [teamoesterreich.view-state :as v-state]
            ))



(defonce LINE-HEIGHT 60)

(defn get-data-by-tomId [tomId]
  (let [!entry (r/cursor v-state/app-state [:lr-list :data "elms" (str tomId)])]
    (if @!entry
      @!entry
      {:index tomId :tomId tomId :user-lastName "loading..."})))



(defn filter-fn [rows search]
  ;;(println "filter-fn " (count rows) search)
  (filter (fn [e]
            (re-find
              (re-pattern (reduce (fn [c e] (str c "(?=.*" e ")")) "(?i)^" (clojure.string/split search " ")))
              (str (:user-tomId e) "#" (:user-firstName e) "#" (:user-lastName e) "#" (:user-email e) "#" (:user-phoneNumber e))))
          rows))



(defn select-renderer [!st-selected]
  (fn [js-parm]
    (r/as-element
      (let [{rowData "rowData"} (js->clj js-parm)
            tomId (get rowData "tomId")]
        [:div
         [mui/checkbox
          {:onChange (fn [_ val]
                       (log/debug ":onChange" tomId val (clj->js @!st-selected))
                       (if (coll? @!st-selected)
                         (swap! !st-selected assoc tomId val)
                         (reset! !st-selected {tomId val})))
           :checked  (if (get-in @!st-selected [tomId]) true false)
           }]]

        ))))


(defn debug-renderer [!st]
  (fn [js-parm]
    (r/as-element
      (let [{rowData "rowData"} (js->clj js-parm)
            tomId (get rowData "tomId")
            ]
        ;(log/debug "debug-renderer" elm)
        [:span (str tomId)]

        ))))

(defn admin-renderer [!st]
  (fn [js-parm]
    (r/as-element
      (let [{rowData "rowData"} (js->clj js-parm)
            tomId (get rowData "tomId")
            ]
        ;(log/debug "debug-renderer" elm)


        ;




        [:span (str tomId)]

        ))))


(defn clearance-renderer [!show-clearance-modal !show-extend-modal !loaded !cursor]
  (fn [js-parm]
    (r/as-element
      (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
            tomId (get rowData "tomId")
            clearance-uuid (get-in rowData ["lrClearance" "lrClearance-uuid"])]
        (cond
          ;extendable
          (get rowData "extendAble")
          [mui/button {:variant "outlined"
                       :onClick (fn []
                                  (reset! !cursor tomId)
                                  (reset! !show-extend-modal tomId))} "verlängern"]
          ;edit
          (get rowData "lrClearance-valid")
          [mui/button {:variant "outlined"
                       :onClick (fn []
                                  (reset! !cursor tomId)
                                  (reset! !show-clearance-modal tomId))} "ändern"]

          ;create
          (get rowData "clearAble")
          [mui/button {:style   {:backgroundColor "#c6c6c6"}
                       :variant "outlined"
                       :color   "primary"
                       :onClick (fn []
                                  (reset! !cursor tomId)
                                  (reset! !show-clearance-modal tomId))
                       } "freigeben"]


          ;reject
          (get rowData "rejectAble") [mui/button {:style   {:backgroundColor "#c6c6c6"}
                                                  :variant "outlined"
                                                  :onClick (fn [] (d-lrClearance/>reject-clearance clearance-uuid #(reset! !loaded nil)))
                                                  } "ablehnen"]

          )))))

(defn qualification-renderer [!show-qualification-modal !loaded !cursor]
  (fn [js-parm]
    (r/as-element
      (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
            tomId (get rowData "tomId")
            clearance-uuid (get-in rowData ["lrClearance-uuid"])]
        (cond
          (and (get rowData "qualificationWait") (not (get rowData "lrClearance-qualification-is-extendable")))
          [mui/button {:style   {:backgroundColor "#c6c6c6"}
                       :variant "outlined"
                       :color   "primary"
                       :onClick (fn []
                                  (reset! !cursor tomId)
                                  (reset! !show-qualification-modal tomId))
                       } "bestätigen"]


          ;qualificationMissing
          (or (not (get rowData "qualificationWait")) (get rowData "lrClearance-qualification-is-extendable"))
          [mui/button {:style   {:backgroundColor "#c6c6c6"}
                       :variant "outlined"
                       :onClick (fn []
                                  (reset! !cursor tomId)
                                  (reset! !show-qualification-modal tomId))
                       } "manuell"]
          )))))



(defn confirm-identity-renderer [!show-identity-modal !selected-document !cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")
          doc-status (get-in rowData ["lrClearance-status-identityDocument"])
          doc-path (get-in rowData ["lrClearance-identityDocument"])
          doc-uuid (get-in rowData ["lrClearance-identityDocument-uuid"])
          ]
      ;(log/debug "confirm-identity-renderer" rowData)
      (r/as-element
        [:div {:style   {:height          (str LINE-HEIGHT "px")
                         :backgroundColor (case doc-status "rejected" "#525252"
                                                           "validated" "#c5f6c5"
                                                           "waiting" "#fe776f"
                                                           "#f6cecb"
                                                           )
                         :cursor          "hand"
                         }
               :onClick (fn []
                          (reset! !cursor tomId)
                          (reset! !selected-document doc-uuid)
                          (reset! !show-identity-modal tomId)
                          )
               }
         (if (or (nil? doc-path) (= doc-path ""))
           [:span (if (= doc-status "identityValid") "bestätigt" "---")] ;;63736e5b-2628-4236-955f-e6bca91ae33f
           [backend-file/img {:hash     doc-path
                              :preview? true
                              :height   (str LINE-HEIGHT)
                              :style    {:object-fit "contain" :backgroundColor "white"}
                              :alt      (str doc-uuid)
                              }]
           )]
        ))))


(defn confirm-selfdeclaration-renderer [!show-selfdeclaration-modal !selected-document !cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")
          doc-status (get-in rowData ["lrClearance-status-selfExplainDocument"])
          doc-path (get-in rowData ["lrClearance-selfExplainDocument"])
          doc-uuid (get-in rowData ["lrClearance-selfExplainDocument-uuid"])
          ]
      ;(log/debug "confirm-selfDeclaration-renderer" tomId selfDeclarationDocument)
      (r/as-element
        [:div {:style   {:height          (str LINE-HEIGHT "px")
                         :backgroundColor (case doc-status "rejected" "#525252"
                                                           "validated" "#c5f6c5"
                                                           "waiting" "#fe776f"
                                                           "#f6cecb"
                                                           )
                         :cursor          "hand"}
               :onClick (fn []
                          (log/debug "click" tomId doc-path)
                          (reset! !cursor tomId)
                          (reset! !selected-document doc-uuid)
                          (reset! !show-selfdeclaration-modal tomId)
                          )
               }

         (if (or (not doc-path) (= "" doc-path))
           [:span (str "---")]
           [backend-file/img {:hash     doc-path
                              :preview? true
                              :height   LINE-HEIGHT
                              :style    {:object-fit "contain" :backgroundColor "white"}
                              :alt      (str doc-uuid)
                              }]
           )]
        ))))

(defn confirm-extend-renderer [!show-training-modal !selected-document !cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")
          doc-status (get-in rowData ["lrClearance-status-extendDocument"])
          doc-path (get-in rowData ["lrClearance-extendDocument"])
          doc-uuid (get-in rowData ["lrClearance-extendDocument-uuid"])
          ]
      (log/debug "confirm-qualification-renderer" tomId "--" doc-uuid)
      (r/as-element
        [:div {:style   {:height          (str LINE-HEIGHT "px")
                         :backgroundColor (case doc-status "rejected" "#525252"
                                                           "waiting" "#fe776f"
                                                           "#f6cecb"
                                                           )
                         :cursor          "hand"}
               :onClick (fn []
                          (reset! !cursor tomId)
                          (reset! !selected-document doc-uuid)
                          (reset! !show-training-modal tomId)
                          )
               }
         (if (or (nil? doc-path) (= doc-path ""))
           [:span (str "---")]
           [backend-file/img {:hash     doc-path
                              :preview? true
                              :height   (str LINE-HEIGHT)
                              :style    {:object-fit "contain" :backgroundColor "white"}
                              :alt      (str doc-uuid)
                              }]
           )
         ]
        ))))

(defn confirm-qualification-renderer [!show-qualification-modal !selected-document !cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")
          doc-status (get-in rowData ["lrClearance-status-trainingDocument"])
          doc-status (if (and (get-in rowData ["lrClearance-qualification-is-valid"]))
                       "validated"
                       doc-status)
          doc-path (get-in rowData ["lrClearance-trainingDocument"])
          doc-uuid (get-in rowData ["lrClearance-trainingDocument-uuid"])
          ]
      ;(log/debug "confirm-qualification-renderer" tomId)
      (r/as-element
        [:div {:style   {:height          (str LINE-HEIGHT "px")
                         :backgroundColor (case doc-status "rejected" "#525252"
                                                           "validated" "#c5f6c5"
                                                           "waiting" "#fe776f"
                                                           "#f6cecb"
                                                           )
                         :cursor          "hand"}
               :onClick (fn []
                          (reset! !cursor tomId)
                          (reset! !selected-document doc-uuid)
                          (reset! !show-qualification-modal tomId)
                          )
               }
         (if (or (nil? doc-path) (= doc-path ""))
           [:span (str "---")]
           [backend-file/img {:hash     doc-path
                              :preview? true
                              :height   (str LINE-HEIGHT)
                              :style    {:object-fit "contain" :backgroundColor "white"}
                              :alt      (str doc-uuid)
                              }]
           )
         (when (get-in rowData ["lrClearance-qualification-message"])
           [:span {:style {:color "darkblue"} :title (get-in rowData ["lrClearance-qualification-message"])}
            [:br] (str "" (get-in rowData ["lrClearance-qualification-message"]))])
         ]
        ))))


(defn email-cell-renderer [!cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")]
      (r/as-element
        [mui/icon-button {:label   "Email senden"
                          :title   "Email senden"
                          :onClick (fn []
                                     (reset! !cursor tomId)
                                     (swap! v-state/app-state assoc-in [:toe-map :activeSendMail] tomId))
                          } [email {:fontSize "small"}]]))))

(defn correspondence-cell-renderer [!show-correspondence-modal !cursor]
  (fn [js-parm]
    (let [{rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")]
      ;(log/debug "correspondence-cell-renderer" (js->clj js-parm))
      (r/as-element
        [mui/icon-button {:label   "Korrespondenz"
                          :title   "Korrespondenz"
                          :onClick (fn []
                                     (reset! !cursor tomId)
                                     (reset! !show-correspondence-modal tomId))
                          } [speaker-notes {:fontSize "small"}]]))))





(defn marker-renderer [!st]
  (fn [js-parm]
    (let [!show-marker-modal (r/cursor !st [:show-marker-modal])
          {rowData "rowData" rowIndex "rowIndex"} (js->clj js-parm)
          tomId (get rowData "tomId")
          lrOwner (get rowData "lrOwner")
          markerNotes (get rowData "lrMarkerNotes")
          lrMarker (get rowData "lrMarker")]
      (r/as-element

        [:div {:style   {:width "98%" :height "98%" :border "1px solid grey" :padding "14px 2px 0 2px" :cursor "hand"}
               :onClick (fn []
                          (log/debug "show-marker-modal " tomId)
                          (reset! !show-marker-modal rowData))
               :title   (str markerNotes)
               }
         (marker-modal/markerIcon lrMarker)

         [:br]
         [:span {:style {:fontSize "8px"}} (or lrOwner "-")]]
        ))))

(defn img-renderer [!st]
  (fn [js-parm]
    (let [!preview-modal (r/cursor !st [:preview-modal])
          !selected-document (r/cursor !st [:selected-document])
          {cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        (if (= (str "" cell-data) "")
          [:span (str "" cell-data)]
          [backend-file/img {:hash     cell-data
                             :preview? true
                             :height   (str LINE-HEIGHT)
                             :style    {:object-fit "contain" :backgroundColor "white"}
                             :alt      "img"
                             :onClick  (fn []
                                         ;;; TODO (reset! !selected-document cell-data)
                                         (reset! !preview-modal true))
                             }]
          )
        ))))

(defn docList-renderer [!st]
  (fn [js-parm]
    (let [!show-preview (r/cursor !st [:show-preview])
          !selected-document (r/cursor !st [:selected-document])
          {cell-data "cellData"} (js->clj js-parm)]
      (r/as-element
        (for [doc cell-data]
          [backend-file/img {:hash     (nth doc 2)
                             :preview? true
                             :height   (str LINE-HEIGHT)
                             :style    {:object-fit "contain" :backgroundColor "white"}
                             :alt      "img"
                             :onClick  (fn []
                                         ;(js/console.log "clicked " (nth doc 2))
                                         (reset! !selected-document (nth doc 2))
                                         (reset! !show-preview true)
                                         )
                             }]
          )
        ))))

(defn org-renderer [ALL_DST_LIST]
  (fn [js-parm]
    (let [{rowData "rowData"} (js->clj js-parm)
          cell-data (get rowData "orgId")]
      ;(js/console.log "rowData" (clj->js (get rowData "orgId")))
      (r/as-element
        [:span (or (get ALL_DST_LIST cell-data) (str "" cell-data))]))))

(defn edit-cell-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)]
    (r/as-element
      [mui/icon-button {:label   "bearbeiten"
                        :title   "bearbeiten"
                        :onClick (fn []
                                   (log/debug "action edit-cell-renderer : " cell-data)
                                   (a/open-lr-user-view cell-data))
                        } [ic-edit/edit {:fontSize "small"}]])))

(defn ticket-cell-renderer [js-parm]
  (let [{rowData "rowData" ticket-uuid "cellData"} (js->clj js-parm)
        tomId (get rowData "tomId")]
    (r/as-element
      (if ticket-uuid
        [mui/icon-button {:label   "bearbeiten"
                          :onClick #(swap! v-state/app-state assoc-in [:toe-map :openTicket] ticket-uuid)
                          } [ic-warning/warning {:fontSize "small" :style {:color "red"}}]]
        [mui/icon-button {:label   "Warnung/Erinnerung erstellen"
                          :title   "Warnung/Erinnerung erstellen"
                          :onClick #(swap! v-state/app-state assoc-in [:toe-map :newTicket] tomId)
                          } [ic-add/add {:fontSize "small"}]]
        ))))

(defn date-renderer [js-parm]
  (let [{cell-data "cellData"} (js->clj js-parm)
        ;l-date (date-h/parse-local-date cell-data)
        ]
    ;(js/console.log l-date)
    (r/as-element
      [:span (if (> (count cell-data) 10)
               (str (subs cell-data 6 8) "." (subs cell-data 4 6) "." (subs cell-data 0 4))
               "-")])))


(defn inside-table [!st rows]
  (fn [m]
    (let [width (aget m "width")
          height (aget m "height")
          !invalidated (r/cursor !st [:invalidated])
          !sort (r/cursor !st [:sort])
          !reverse (r/cursor !st [:reverse])
          !tab (r/cursor !st [:tab])
          !cursor (r/cursor v-state/app-state [:lr-list :cursor])
          !loaded (r/cursor v-state/app-state [:lr-list :loaded])
          !show-correspondence-modal (r/cursor !st [:show-correspondence-modal])
          !show-extend-clearance-modal (r/cursor !st [:show-extend-clearance-modal])
          !show-clearance-modal (r/cursor !st [:show-clearance-modal])
          !show-training-modal (r/cursor !st [:show-training-modal])
          !show-qualification-modal (r/cursor !st [:show-qualification-modal])
          !show-selfdeclaration-modal (r/cursor !st [:show-selfdeclaration-modal])
          !show-identity-modal (r/cursor !st [:show-identity-modal])
          !selected-document (r/cursor !st [:selected-document])
          !preview-modal (r/cursor !st [:preview-modal])
          !st-selected (r/cursor v-state/app-state [:lr-list :selected])

          _ (d-organisation/get-store-organisations)
          !organisations (r/cursor v-state/app-state [:organisations])
          ALL_DST_LIST (or (into {} (d-organisation/get-all-multi-filter-list @!organisations)) {})

          cursorIndex (reduce (fn [c {tomId :tomId i :index}] (if (= @!cursor tomId) i c)) 0 rows)
          ]


      (log/debug "cursorIndex" @!cursor cursorIndex)
      (r/as-element
        [:> rv/Table
         {:headerHeight    50
          :height          (- height 50)
          :rowCount        (count rows)
          :scrollToIndex   cursorIndex
          ;:onScroll           (fn [a b c] (println "onScroll " a b c))
          ;:scrollToAlignment "start"
          :rowGetter       (fn [i]
                             (let [index (aget i "index")
                                   tomId (when (and (>= index 0) (< index (count rows))) (get (nth rows index) :tomId))]
                               (clj->js (get-data-by-tomId tomId))))
          :rowClassName    (fn [i]
                             (let [index (aget i "index")
                                   tomId (when (and (>= index 0) (< index (count rows))) (get (nth rows index) :tomId))]
                               (cond
                                 (= @!cursor tomId) "table-selected"
                                 (odd? (aget i "index")) "table-odd"
                                 :else "table-even")))
          :sort            (fn [s]
                             (log/debug "sort called" (count rows))
                             (swap! !st assoc :sort (aget s "sortBy") :reverse (= "DESC" (aget s "sortDirection")))
                             (reset! !invalidated true)
                             )
          :sortBy          @!sort
          :sortDirection   (if @!reverse "DESC" "ASC")

          :rowHeight       (+ LINE-HEIGHT 6)
          :width           width
          :headerClassName "headerColumn"
          :className       "LebensretterList"}
         [:> rv/Column
          {:label        (r/as-element [mui/checkbox {:disabled true}])
           :dataKey      "tomId"
           :disableSort  true
           :className    "bordered exampleColumn"
           :cellRenderer (select-renderer !st-selected)
           :width        50} [:a {:href ""}]]

         [:> rv/Column
          {:label        (r/as-element [ic-edit/edit])
           :disableSort  true
           :dataKey      "tomId"
           :className    "bordered exampleColumn"
           :cellRenderer edit-cell-renderer
           :width        40}]


         [:> rv/Column
          {:label     "TomId"
           :dataKey   (name :tomId)
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     50}]


         [:> rv/Column
          {:label        (r/as-element [ic-warning/warning {:style {:color "red"}}])
           :dataKey      "last-ticket"
           :className    "bordered exampleColumn"
           :cellRenderer ticket-cell-renderer
           :width        50}]

         [:> rv/Column
          {:label        (r/as-element [label-important {:style {:color "black"}}])
           :dataKey      "lrMarker"
           :className    "bordered exampleColumn"
           :cellRenderer (marker-renderer !st)
           :width        60}]

         [:> rv/Column
          {:label     "Vorname"
           :dataKey   (name :firstName)
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     120}]

         [:> rv/Column
          {:label     "Nachname"
           :dataKey   (name :lastName)
           :style     {:textAlign "left" :overflow "hidden"}
           :className "bordered exampleColumn"
           :width     120}]
         ;

         [:> rv/Column
          {:label        "Dienststelle"
           :cellRenderer (org-renderer ALL_DST_LIST)
           :dataKey      (name :orgId)
           :className    "bordered exampleColumn"
           :width        120}]



         (when (not= @!tab "profileMissing")
           [:> rv/Column
            {:label        (r/as-element [:span "Änderung" [:br] "Dokumente"])
             :dataKey      (name :lastDocumentTime)
             :cellRenderer date-renderer
             :className    "bordered exampleColumn"
             :width        100}])

         (when (or (= @!tab "documentsMissing")
                   (= @!tab "profileMissing")
                   (= @!tab "waiting"))
           [:> rv/Column
            {:label     (r/as-element [:span "Anzahl" [:br] "Dokumente"])
             :dataKey   (name :cntDocuments)
             :className "bordered exampleColumn"
             :width     120}])

         (when (and (not= @!tab "profileMissing") (not= @!tab "qWaiting") (not= @!tab "qMissing"))
           [:> rv/Column
            {:label        (r/as-element [:span "Identifikation"])
             :cellRenderer (confirm-identity-renderer !show-identity-modal !selected-document !cursor)
             :dataKey      (name :lrClearance)
             :className    "bordered exampleColumn"
             :width        120}])

         (when (and (not= @!tab "profileMissing") (not= @!tab "qWaiting") (not= @!tab "qMissing"))
           [:> rv/Column
            {:label        (r/as-element [:span "Selbst-" [:br] "erklärung"])
             :cellRenderer (confirm-selfdeclaration-renderer !show-selfdeclaration-modal !selected-document !cursor)
             :dataKey      (name :lrClearance)
             :className    "bordered exampleColumn"
             :width        120}])


         (when (or (= @!tab "qWaiting") (= @!tab "qMissing") (= @!tab "qExtendable"))
           [:> rv/Column
            {:label        "Qualifikation"
             :cellRenderer (confirm-qualification-renderer !show-training-modal !selected-document !cursor)
             :dataKey      (name :lrClearance)
             :className    "bordered exampleColumn"
             :width        120}])

         [:> rv/Column
          {:label        (r/as-element [email])
           :disableSort  true
           :dataKey      (name :tomId)
           :cellRenderer (email-cell-renderer !cursor)
           :className    "bordered exampleColumn"
           :width        50}]

         [:> rv/Column
          {:label        (r/as-element [speaker-notes])
           :disableSort  true
           :dataKey      (name :tomId)
           :cellRenderer (correspondence-cell-renderer !show-correspondence-modal !cursor)
           :className    "bordered exampleColumn"
           :width        50}]

         (when (and (not= @!tab "profileMissing") (not= @!tab "documentsMissing") (not= @!tab "documentsMissing")
                    (not= @!tab "qWaiting") (not= @!tab "qMissing") (not= @!tab "qExtendable"))
           [:> rv/Column
            {:label        "Freigabe"
             :disableSort  true
             :cellRenderer (clearance-renderer !show-clearance-modal !show-extend-clearance-modal !loaded !cursor)
             :dataKey      (name :lrClearance-wop)
             :className    "bordered exampleColumn"
             :width        120}])


         (when (or (= @!tab "qExtendable"))
           [:> rv/Column
            {:label        "Neue Qualifikation"
             :cellRenderer (confirm-extend-renderer !show-training-modal !selected-document !cursor)
             :dataKey      (name :lrClearance)
             :className    "bordered exampleColumn"
             :width        120}])

         (when (or (= @!tab "qMissing") (= @!tab "qExtendable"))
           [:> rv/Column
            {:label        "Manuell"
             :disableSort  true
             :cellRenderer (qualification-renderer !show-qualification-modal !loaded !cursor)
             :dataKey      (name :lrClearance-wop)
             :className    "bordered exampleColumn"
             :width        140}])


         (when (or (= @!tab "documentsMissing") (= @!tab "waiting") (= @!tab "qMissing"))
           [:> rv/Column
            {:label        "Weitere Dokumente"
             :disableSort  true
             :cellRenderer (docList-renderer !st)
             :dataKey      (name :allDocuments)
             :className    "bordered exampleColumn"
             :width        300}])

         (when (= @!tab "profileMissing")
           [:> rv/Column
            {:label     "Voraussetzungen"
             :style     {:textAlign "left"}
             :dataKey   (name :lr-missing)
             :className "bordered exampleColumn"
             :width     300}])

         (when (or (= @!tab "active") (= @!tab "extendable") (= @!tab "expired"))
           [:> rv/Column
            {:label        (r/as-element [:span "Freigegeben" [:br] "ab"])
             :cellRenderer date-renderer
             :dataKey      (name :lrClearance-start)
             :className    "bordered exampleColumn"
             :width        120}])

         (when (or (= @!tab "active") (= @!tab "extendable") (= @!tab "expired"))
           [:> rv/Column
            {:label        (r/as-element [:span "Freigegeben" [:br] "bis"])
             :cellRenderer date-renderer
             :dataKey      (name :lrClearance-end)
             :className    "bordered exampleColumn"
             :width        120}])

         (when (or (= @!tab "qWaiting") (= @!tab "qMissing") (= @!tab "active") (= @!tab "qExtendable"))
           [:> rv/Column
            {:label     "LR Typ"
             :dataKey   (name :lrClearance-type)
             :className "bordered exampleColumn"
             :width     100}])

         (when (or (= @!tab "active"))
           [:> rv/Column
            {:label        "Qualifikation"
             :cellRenderer (confirm-qualification-renderer !show-training-modal !selected-document !cursor)
             :dataKey      (name :lrClearance)
             :className    "bordered exampleColumn"
             :width        120}])


         (when (or (= @!tab "active") (= @!tab "extendable") (= @!tab "expired") (= @!tab "qExtendable"))
           [:> rv/Column
            {:label        (r/as-element [:span "Qualifikation" [:br] "bis"])
             :cellRenderer date-renderer
             :dataKey      (name :lrClearance-qualification-until)
             :className    "bordered exampleColumn"
             :width        120}])

         ]))))

(defn preview-modal [!selected-document !show-preview]
  [preview-modal/modal @!selected-document !show-preview])


(defn table [!st rows]
  (let [
        !st-selected (r/cursor v-state/app-state [:lr-list :selected])
        !cursor (r/cursor v-state/app-state [:lr-list :cursor])
        !show-preview (r/cursor !st [:show-preview])
        !show-clearance-modal (r/cursor !st [:show-clearance-modal])
        !show-extend-clearance-modal (r/cursor !st [:show-extend-clearance-modal])
        !show-extend-modal (r/cursor !st [:show-extend-modal])
        !show-identity-modal (r/cursor !st [:show-identity-modal])
        !show-marker-modal (r/cursor !st [:show-marker-modal])
        !show-selfdeclaration-modal (r/cursor !st [:show-selfdeclaration-modal])
        !show-training-modal (r/cursor !st [:show-training-modal])
        !show-qualification-modal (r/cursor !st [:show-qualification-modal])
        !show-doc-assign-modal (r/cursor !st [:!show-doc-assign-modal])
        !show-correspondence-modal (r/cursor !st [:show-correspondence-modal])
        !selected-document (r/cursor !st [:selected-document])
        ]
    (fn []
      [:div
       [preview-modal !selected-document !show-preview]
       [marker-modal/modal-by-tomId !show-marker-modal]
       [(extend-modal/modal-by-tomId !show-extend-clearance-modal)]
       [(document-extend-modal/modal-by-tomId !show-extend-modal !selected-document !show-doc-assign-modal)]
       [(clearance-modal/modal-by-tomId !show-clearance-modal)]
       [(qualification-modal/modal-by-tomId !show-qualification-modal)]
       [(document-identity-modal/modal-by-tomId !show-identity-modal !selected-document !show-doc-assign-modal)]
       [(document-selfExplain-modal/modal-by-tomId !show-selfdeclaration-modal !selected-document !show-doc-assign-modal)]
       [(document-training-modal/modal-by-tomId !show-training-modal !selected-document !show-doc-assign-modal)]
       [(document-assign-modal/modal-by-tomId !st)]
       [(correspondence-modal/modal-by-tomId !show-correspondence-modal)]
       (log/debug "rerender table")
       [:> rv/AutoSizer
        {:style         {:height "100%"}
         :data-cursor   (str @!cursor)
         :data-selected (str @!st-selected)}
        (inside-table !st rows)]
       ])))










